import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../../hook/use-http";
import NoData_Coral from "../NoData_Coral";
import ChartLoader_Coral from "../ChartLoader_Coral";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitialstates_coral";
import * as $ from "jquery";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register the required components from Chart.js
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend
);

function DcdcTemp_Coral({ apiend, gloablfilter, title }) {
  const [maxData, setMaxData] = useState({});
  const [medianData, setMedianData] = useState({});
  const [labelLength, setLabelLength] = useState(0);
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const appyData = (data) => {
    setMaxData({
      max1: data.max_temp_1,
      max2: data.max_temp_2,
    });

    setMedianData({
      median1: data.median_temp_1,
      median2: data.median_temp_2,
    });

    setLabelLength(Array.from({ length: data.max_temp_1.length }, (_, i) => i + 1));
  };

  const data = {
    labels: labelLength,
    datasets: [
      {
        label: "Median DCDC Temp 1",
        data: medianData.median1 || [],
        borderColor: "rgb(20, 148, 172)",
        fill: false,
        tension: 0.1,
      },
      {
        label: "Median DCDC Temp 2",
        data: medianData.median2 || [],
        borderColor: "rgb(12, 100, 150)",
        fill: false,
        tension: 0.1,
      },
      {
        label: "Max DCDC Temp 1",
        data: maxData.max1 || [],
        borderColor: "#ffa650",
        fill: false,
        tension: 0.1,
      },
      {
        label: "Max DCDC Temp 2",
        data: maxData.max2 || [],
        borderColor: "#ff7f0e",
        fill: false,
        tension: 0.1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        position: "top",
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: "Discharge Cycle",
          font: {
            size: 11,
          },
        },
      },
      y: {
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: "Temperature",
          font: {
            size: 12,
          },
        },
      },
    },
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + apiend,
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  return (
    <>
      <div className="v-title chartbox drive_graph p-0">
        <div className="titlebg titlebd_drive box_title pb-2 pt-2">{title}</div>
        <div className="chartHGT">
          {isLoading ? (
            <ChartLoader_Coral />
          ) : !maxData.max1 || maxData.max1.length === 0 ? (
            <NoData_Coral />
          ) : (
            <div className="ml-1 mb-1 mr-1" style={{ height: "235px" }}>
              <Line data={data} options={options} height={"200px"} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default DcdcTemp_Coral;
